import gql from 'graphql-tag'

export const insertBonus = ({ bonusData, bonusRoles }) => {
	return {
		mutation: gql`
			mutation ($bonus: bonuses_insert_input!) {
				insert_bonuses_one(object: $bonus) {
					id
				}
			}
		`,
		variables: {
			bonus: {
				...bonusData,
				bonuses_roles: {
					data: bonusRoles.map(rol => ({
						rol_id: rol.id
					}))
				}
			}
		}
	}
}
